import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../../store/authStore';
import { formatBSDateFull } from '../../utils/bs';

export default function Header() {
  const logout      = useAuthStore((s) => s.logout);
  const queryClient = useQueryClient();

  function handleLogout() {
    queryClient.clear();
    logout();
  }

  return (
    <header className="h-14 bg-hydro-card border-b border-hydro-border flex items-center justify-between px-6 flex-shrink-0">
      <div />

      <div className="flex items-center gap-4">
        <span className="text-xs text-slate-400">
          {formatBSDateFull(new Date())}
        </span>

        <button
          onClick={handleLogout}
          className="text-xs text-slate-500 hover:text-slate-900 transition-colors px-2 py-1 rounded hover:bg-black/5"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
